import React from "react";

const BarChart = ({ width, background, value }) => {
  return  (
    <div
      className="barChart" 
      style={{ width: `calc(${width}% + 10px)`, background: background }}>
      {value}
    </div>
  );
};    

export default BarChart;